import { orpc } from "@/lib/orpc";

/** The inbox's one input, shared by the list, the rail badge and the live updates, so they read
 * one cache entry. */
const INBOX_INPUT = { limit: 200 } as const;
export const inboxQuery = () =>
  orpc.messaging.conversations.list.queryOptions({ input: INBOX_INPUT, staleTime: 30_000 });

/** One conversation as its screen reads it: fresh for half a minute, since live events patch it
 * and invalidate it whenever its people or settings change. */
export const conversationQuery = (conversationId: string) =>
  orpc.messaging.conversations.get.queryOptions({ input: { conversationId }, staleTime: 30_000 });

export const capabilitiesQuery = () =>
  orpc.messaging.capabilities.queryOptions({ staleTime: 5 * 60_000 });
